import { UserDetail } from '../../types/api';
import { ASSETS } from '../../constants/assets';

export const getMockClientProfile = (userId: string): UserDetail => ({
  userId,
  uniqueId: 'S4U-98273',
  firstName: 'Anjali',
  middleName: '',
  lastName: 'Sharma',
  email: 'anjali.sharma@email.com',
  phoneNumber: '+91 98450 22334',
  gender: 'Female',
  dateOfBirth: '1995-08-15',
  emailVerified: true,
  phoneVerified: true,
  createdAt: '2023-08-12T00:00:00.000Z',
  userImage: ASSETS.icons.createUser.person,
  photos: [
    ASSETS.icons.createUser.camera,
    ASSETS.icons.createUser.workBag,
    ASSETS.icons.createUser.lifestyleTree,
    ASSETS.icons.createUser.person,
  ],
  activePlanDetails: {
    hasActivePlan: true,
    planName: 'Premium Gold Plan',
    durationMonths: 12,
    totalPrice: 15000,
    startDate: '2023-08-12T00:00:00.000Z',
    endDate: '2024-08-12T00:00:00.000Z',
  },
  basicDetails: {
    height: { height_id: '1', height: "5'6\"" },
    religion: { religion_id: '1', name: 'Hindu', have_sect: false, have_caste: true, have_manglik: true },
    caste: { caste_id: '1', name: 'Brahmin' },
    motherTongue: { mother_tongue_id: '1', name: 'Hindi' },
    marital_status: { marital_status_id: '1', name: 'Never Married' },
    city: { city_id: '1', name: 'Mumbai' },
    state: { state_id: '1', name: 'Maharashtra' },
    country: { country_id: '1', name: 'India' },
  },
  profile: {
    manglik: 'non_manglik',
  },
  education: {
    highestDegree: { degree_id: '1', name: 'MBA in Finance' },
    occupation: { occupation_id: '1', name: 'Senior Financial Analyst' },
    companyName: 'Goldman Sachs',
    incomeCurrency: { income_currency_id: '1', name: 'INR', symbol: '₹' },
    annualIncome: 2100000,
  },
  lifestyle: {
    diet: { diet_id: '1', name: 'Vegetarian' },
  },
  family: {
    familyType: { family_type_id: '1', name: 'Nuclear Family' },
    fatherOccupation: { father_occupation_id: '1', name: 'Retired Govt. Officer' },
    aboutFamily: 'Moderate / Modern',
  },
});
